// extracted by mini-css-extract-plugin
export default {"menu-btn":"styles_menu-btn__AXSmQ","menu-item":"styles_menu-item__h9LUJ"};